<template>
  <div class="iv-benner-box iv-main-width">
    <div class="benner-left">
      <Swiper v-if="carouselList.length" class="iv-carou gallery-top" ref="swiperTop" :options="swiperOptions">
        <SwiperSlide class="iv-swiper-wrapper" v-for="(v, k) in carouselList" :key="k">
          <div class="iv-swiper-img" :style="getStyles(v)" @click="onDetail(v)"></div>
          <div class="iv-swiper-tit">
            <h2 :title="v.name" class="iv-fs-24 iv-fw-b iv-fc-85 iv-ellipsis-1 iv-pointer iv-hover-color" @click="onDetail(v)">{{ v.name }}</h2>
            <p :title="v.desc" class="iv-m-t-20 iv-fs-14 iv-fc-45 iv-ellipsis-3">{{ v.desc }}</p>
          </div>
        </SwiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </Swiper>
    </div>
    <div class="benner-right">
      <div class="right-title">
        <span class="iv-fs-20 iv-fw-b iv-fc-85">重大新闻</span>
        <span class="iv-more-box iv-pointer iv-fs-14 iv-fc-65" @click="onMoreClick">更多
          <span class="iv-m-l-8">
            <IconFont type="gengduo" class="iv-fs-12 iv-fc-65"></IconFont>
          </span>
        </span>
      </div>
      <ul>
        <li v-for="(item, inx) in newsList" :key="inx">
          <span class="iv-fc-45 iv-fs-14"><IconFont type="time-circle" class="iv-fs-16 iv-main-color iv-m-r-8"></IconFont>{{ timeFormat(item.createTime, 'yyyy-MM-dd') }}</span>
          <p class="iv-m-t-8 iv-fs-16 iv-fc-85 iv-ellipsis-2 iv-pointer iv-hover-color" @click="onDetail(item)">{{item.blogDesc || ''}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import IconFont from '@/components/iconfont'
import { timeFormat } from '@/utils'
// swiper
import {Swiper as SwiperClass, Pagination, Autoplay} from 'swiper/core'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/swiper-bundle.css'

SwiperClass.use([Pagination, Autoplay])
const {Swiper, SwiperSlide} = getAwesomeSwiper(SwiperClass)

export default {
  components: { IconFont, Swiper, SwiperSlide },
  props: {},
  data () {
    return {
      carouselList: [],
      swiperOptions: {
        // loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
          renderBullet: (index, className) => {
            let _time = this.carouselList[index].createTime || new Date().getTime()
            return `<div class="${className}"><span>${this.timeFormat(_time, 'dd')}</span><p>${this.timeFormat(_time, 'yyyy.MM')}</p></div>`
          }
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      },
      newsList: []
    }
  },
  created () {
    this.carouselList = []
    this.getmanagerThought()
    this.getImportantNews()
  },
  methods: {
    timeFormat,
    getmanagerThought() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'pic_news',
          rowNum: '5'
        }
      }).then(({data}) => {
        this.carouselList = data.data['pic_news']
      })
    },
    getImportantNews() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'important_news',
          rowNum: '5'
        }
      }).then(({data}) => {
        this.newsList = data.data['important_news']
      })
    },
    getStyles (v) {
      return {
        // backgroundImage: `url(${require('@/assets/images/new-home/static/img1.png')})`
        backgroundImage: `url(${this.getImgPath(v.imageUrl)})`
      }
    },
    getImgPath(imageUrl) {
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_API + imageUrl
    },
    onDetail (item) {
      this.$emit('onDetail', item)
    },
    onMoreClick () {
      this.$emit('moreClick', {
        code: 'important_news'
      })
    },
    onSwiperClick (item) {
      this.$emit('onDetail', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/new-blue/variable.scss';
.iv-benner-box {
  padding: 40px 0;
  background: initial;
  overflow: hidden;
  .benner-left {
    width: calc(66.66% - 20px);
    height: 666px;
    overflow: hidden;
    float: left;
    background: #fff;
    position: relative;
    .swiper-pagination {
      position: absolute;
      bottom: 123px;
      left: 0;
      height: 80px;
      text-align: left;
    }
    /deep/ .swiper-pagination-bullet {
      background: none;
      width: 80px;
      height: 80px;
      color: rgba(0, 0, 0, 0.85);
      background: rgba(255, 255, 255, 0.45);
      border-radius: 0;
      text-align: center;
      opacity: 1;
      margin: 0;
      margin-right: 2px;
      span {
        font-size: 40px;
        font-weight: 700;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        margin-top: -6px;
      }
      &.swiper-pagination-bullet-active {
        background: #fff;
        color: $iv-main-color;
      }
    }
    .iv-carou {
      height: 100%;
      .iv-swiper-img {
        height: 543px;
        overflow: hidden;
        background-size: cover;
      }
      .iv-swiper-tit {
        padding: 40px;
        h2 {
          max-height: 32px;
          overflow: hidden;
        }
        p {
          max-height: 66px;
          overflow: hidden;
        }
      }
    }
  }
  .benner-right {
    width: calc(33.33% - 20px);
    height: 666px;
    overflow: hidden;
    float: right;
    background: url('~@/assets/images/new-home/zdxwbg.png') no-repeat;
    background-size: cover;
    .right-title {
      display: flex;
      width: 100%;
      height: 56px;
      padding: 14px 20px;
      align-items: center;
      background-color: rgba(0, 94, 186, 0.09);
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        height: 24px;
        width: 3px;
        top: 16px;
        background-color: $iv-main-color;
      }
      .iv-more-box {
        margin-left: auto;
      }
    }
    ul {
      padding: 0 20px;
      li {
        padding: 20px 0px;
        border-bottom: 1px dashed rgba(0, 0, 0, 0.14);
        p {
          min-height: 48px;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>